"use client";

import { useState, useEffect } from "react";
import MentorshipCard from "./MentorshipCard";

export default function MentorshipSection({ programs }) {
  const [isDesktop, setIsDesktop] = useState(false);

  // Detect desktop vs. mobile (>= 1024px)
  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <section className={`pb-6 pt-10 ${isDesktop ? 'w-[80%]' : 'w-[90%] md:w-[80%]'} mx-auto`} id="mentorship">
        <div className="mb-12">
        <h2 className="text-[#002726] text-xl md:text-base font-medium uppercase mb-1">EXPLORE YOUR POSSIBILITIES</h2>
        <h3 className="text-[#002726] text-3xl md:text-4xl font-medium">Your Industry, Your Path</h3>
      </div>
      <h2 className={`text-[#002726] font-medium mb-6 ${isDesktop ? 'text-2xl' : 'text-xl md:text-xl'}`}>
        Mentorship Programs
      </h2>
      
      {isDesktop ? (
        // Desktop: 3 columns grid with vertical cards
        <div className="grid grid-cols-3 gap-8">
          {programs.map((program) => (
            <MentorshipCard key={program.id} program={program} isVertical={true} />
          ))}
        </div>
      ) : (
        // Mobile/Tablet: Existing grid layout
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {programs.map((program) => (
            <MentorshipCard key={program.id} program={program} isVertical={false} />
          ))}
        </div>
      )}
    </section>
  );
}